import React from "react";

// ============================================================
// PillRow — Phase 1 horizontally-scrolling pill container.
// ============================================================
// Wraps `.kc-filter-row` from tokens.css: display:flex, gap:
// var(--space-sm), overflow-x:auto, and hides the scrollbar
// via `scrollbar-width:none` + `::-webkit-scrollbar{display:none}`.
// Never wraps to a second line.
// ============================================================
export function PillRow({ className = "", children, ...rest }) {
  const combined = ["kc-filter-row", className].filter(Boolean).join(" ");
  return (
    <div className={combined} role="group" {...rest}>
      {children}
    </div>
  );
}

export default PillRow;
